import React, { Fragment } from "react"; // Import React and Fragment from React library
import ReactPlayer from "react-player/lazy"; // Import ReactPlayer component from react-player/lazy
import { HLSJSVERSION, DOMURL } from "../../utility/constants"; // Import HLSJSVERSION and DOMURL constants

// Define CommonPlayer functional component
const CommonPlayer = ({ isOnended, onPlayerStart, isrefActive, isClass, playerid, parententryid, ref, isUrl, isWidth, isHeight, isControls, isPlaying, isMuted, cookies }) => {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent); // Check if the user's browser is Safari
    const downloadUrl = // Generate download URL for HLS video
        "?Key-Pair-Id=" +
        cookies["CloudFront-Key-Pair-Id"] +
        "&Policy=" +
        cookies["CloudFront-Policy"] +
        "&Signature=" +
        cookies["CloudFront-Signature"];

    // Configuration object for ReactPlayer
    const config = {
        file: {
            forceHLS: !isSafari, // Force HLS playback if not Safari
            forceVideo: !isSafari, // Force video playback if not Safari
            attributes: {
                crossOrigin: "use-credentials", // Set crossOrigin attribute for video element
            },
            hlsOptions: {
                forceHLS: !isSafari, // Force HLS playback if not Safari
                xhrSetup: function (xhr, url) {
                    if (cookies !== undefined) { // Setup XHR request with credentials if cookies are provided
                        xhr.withCredentials = true;
                        xhr.credentials = "include";
                        xhr.open("GET", url + downloadUrl);
                        xhr.setRequestHeader(
                            "Access-Control-Allow-Methods",
                            "POST, GET, OPTIONS, DELETE"
                        );
                        xhr.setRequestHeader("Access-Control-Allow-Credentials", "true");
                        xhr.setRequestHeader("Access-Control-Allow-Origin", DOMURL);
                    }
                },
            },
            hlsVersion: HLSJSVERSION, // Set HLS.js version
        },
    };

    // Function to handle player start
    const handlePlayerStart = () => {
        onPlayerStart(true); // Call onPlayerStart with true parameter
    };

    // Function to handle player ended event
    const handlePlayerended = () => {
        isOnended(true); // Call isOnended with true parameter
    };

    return (
        <Fragment>
            {/* Render ReactPlayer component */}
            <ReactPlayer
                className={isClass} // Set CSS class
                id={playerid !== undefined ? playerid : 0} // Set player id
                ref={isrefActive ? ref : undefined} // Set ref if isrefActive is true
                onEnded={handlePlayerended} // Handle player ended event
                url={isUrl} // Set video URL
                width={isWidth} // Set player width
                height={isHeight} // Set player height
                controls={isControls} // Set whether controls are displayed
                playing={isPlaying} // Set whether the video is playing
                muted={isMuted} // Set whether the video is muted
                config={config} // Set player configuration
                onStart={handlePlayerStart} // Handle player start event
            />
        </Fragment>
    );
};

export default CommonPlayer; // Export CommonPlayer component
